import React, { useEffect, useState } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { partial } from '../../../util/translation/translation';

const p = partial('chat');
const s = partial('shared');

// Hours; empty for permanent
const DURATIONS = ['24', '168', '720', ''];

// Confirms blocking a user, for a time or for good: from the club chats
// unless `title` (given the user's name) and `confirmLabel` say otherwise
const BlockUserModal = ({
  user,
  onCancel,
  onBlock,
  title = (name) => p('blockUserConfirm', { name }),
  confirmLabel = p('blockUser'),
}) => {
  const [duration, setDuration] = useState('24');
  const [reason, setReason] = useState('');

  useEffect(() => {
    setDuration('24');
    setReason('');
  }, [user]);

  return (
    <Modal isOpen={!!user} centered toggle={onCancel}>
      <ModalHeader toggle={onCancel}>{title(user?.userName || '')}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="block-duration">{p('blockDuration')}</Label>
          <Input
            id="block-duration"
            type="select"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
          >
            {DURATIONS.map((hours) => (
              <option key={hours || 'permanent'} value={hours}>
                {p(`blockDuration_${hours || 'permanent'}`)}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className="mb-0">
          <Label for="block-reason">{p('reason')}</Label>
          <Input
            id="block-reason"
            maxLength={500}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          {s('cancel')}
        </Button>
        <Button
          color="danger"
          onClick={() =>
            onBlock({
              ...user,
              reason: reason.trim() || undefined,
              durationHours: duration ? Number(duration) : undefined,
            })
          }
        >
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BlockUserModal;
